document.addEventListener('click', function (e) {
  const button = e.target.closest('[data-enquire-button]');
  const modal = document.querySelector('[data-enquire-modal]');

  if (button && modal) {
    modal.hidden = false;

    const productForm = document.querySelector('form[action*="/cart/add"]');
    const variantInput = productForm?.querySelector('[name="id"]');
    const variantId = variantInput?.value || '';

    modal.querySelector('[data-enquire-product]').value = button.dataset.productTitle || '';

    modal.querySelector('[data-enquire-url]').value = window.location.href;

    let variantLabel = 'Default';

    if (window.product && variantId) {
      const variant = window.product.variants.find((v) => v.id == variantId);

      if (variant && variant.options) {
        variantLabel = variant.options.filter(Boolean).join(' / ');
      }
    }

    modal.querySelector('[data-enquire-variant]').value = variantLabel;
  }

  if (e.target.closest('[data-enquire-close]')) {
    modal.hidden = true;
  }
});
